/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_OverlineInputs */

const en_mk_start_overline = /** @type {(inputs: Mk_Start_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting started`)
};

const id_mk_start_overline = /** @type {(inputs: Mk_Start_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perpindahan`)
};

/**
* | output |
* | --- |
* | "Getting started" |
*
* @param {Mk_Start_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_overline = /** @type {((inputs?: Mk_Start_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_overline(inputs)
	return en_mk_start_overline(inputs)
});